import React, { useState } from 'react';

import { ButtonV2 } from 'components/common/ui';
import { InputFieldV2 } from 'components/common/form-controls';
import { showError } from '@utils';
import { useCampaignsOperations } from '@hooks';
import { marketingServices } from '@services';
import { ModalFooter, ModalV2 } from 'components/common/modals';

const CancelCampaign = (props) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getCampaigns } = useCampaignsOperations(false);

  const handleCancel = async () => {
    try {
      setLoading(true);
      await marketingServices.cancelCampaign(props?.id);
      await getCampaigns();
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleOpenModal = () => {
    setOpen(true);
  };

  return (
    <>
      <InputFieldV2
        type="switch"
        value={props?.value}
        disabled={!props?.value}
        onChange={handleOpenModal}
      />
      <ModalV2
        isOpen={open}
        onClose={handleCloseModal}
        title="Deactivate campaign?"
        maxWidth="sm"
      >
        Are you sure you want to deactivate the campaign?
        <ModalFooter>
          <ButtonV2
            variant="secondary"
            onClick={handleCloseModal}
            loading={loading}
          >
            Cancel
          </ButtonV2>
          <ButtonV2 onClick={handleCancel} loading={loading}>
            Deactivate
          </ButtonV2>
        </ModalFooter>
      </ModalV2>
    </>
  );
};

export default CancelCampaign;
